import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { CloseIcon } from '@/src/components/icon/stroke/CloseIcon';
import { CalendarPointIcon } from '@/src/components/icon/stroke/CalendarPointIcon';
import { FlowPickersActionsBar } from './PickersActionBar';

export const flowDatePicker: Components<Theme>['MuiDatePicker'] = {
  defaultProps: {
    slots: {
      openPickerIcon: CalendarPointIcon,
      clearIcon: CloseIcon,
      actionBar: FlowPickersActionsBar,
    },
    slotProps: {
      openPickerButton: {
        edge: false,
      },
      textField: {
        variant: 'filled',
      },
      // MuiPickersShortcuts does not exist, therefore we have style here
      shortcuts: {
        sx: {
          position: 'relative',
          overflow: 'auto',
          // affects mobiledatepicker.theme
          width: '230px',
          pr: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'center',
          // li items
          '& .MuiListItem-root': {
            padding: '6px 16px',
            minHeight: '0',
          },
          '&:after': {
            content: '""',
            position: 'absolute',
            right: '16px',
            // proportions also changed in pickerslayout.theme
            top: '16px',
            bottom: '16px',
            borderRight: 1,
            borderColor: 'surface.secondary',
          },
        },
      },
    },
    views: ['day', 'month', 'year'],
  },
};

export const flowDesktopDatePicker: Components<Theme>['MuiDesktopDatePicker'] =
  flowDatePicker as Components<Theme>['MuiDesktopDatePicker'];

export const flowStaticDatePicker: Components<Theme>['MuiStaticDatePicker'] =
  flowDatePicker as Components<Theme>['MuiStaticDatePicker'];
